import { Injectable } from '@angular/core';
import { ApiHttpClientService } from '../../api-http-client.service';
import { IResponse } from 'src/app/models/api/response.interface';
import { Subnivel } from 'src/app/models/api/dados-especificos/subnivel';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ApiSubnivelService {

  private baseUrl = 'Subnivel';
  private controller: ApiHttpClientService;

  constructor(
    private api: ApiHttpClientService
  ) {
    this.controller = this.api
      .useBaseUrl(environment.microservice.dadosEspecificos)
      .useBaseUrl(this.baseUrl);
  }

  getByCategoria(categoriaId: string) {
    if (!categoriaId) { throw new Error('Invalid Argument'); }
    return this.controller.unwrap().useLoading().get<Subnivel>(categoriaId);
  }

  getAll() {
    return this.controller.useLoading('waves').get<IResponse<Subnivel[]>>('');
  }

  getAllAtivosInativos() {
    return this.controller.useLoading('waves').get<IResponse<Subnivel[]>>('/BuscarAtivosInativos');
  }

  insert(data: Subnivel) {
    return this.controller.useLoading().post('', data);
  }

  update(data: Subnivel) {
    return this.controller.useLoading().put('', data);
  }

  delete(id: string) {
    if (!id) { throw new Error('Invalid Argument'); }
    return this.controller.useLoading().delete(id);
  }
}
